import Immutable from 'immutable';
import createFormatter from 'react/api/formatters/infomarker.js';

export const createInfoMarkerConf = () => {
  if (Monet.Session && Monet.Session.sessionStorage) {
    const infoMarkerTruckFromSessionStorage = Monet.Session.sessionStorage.getItem('infoMarkerTruck');

    if (infoMarkerTruckFromSessionStorage) {
      const parsedInfoMarkerTruck = JSON.parse(infoMarkerTruckFromSessionStorage);

      const entries = Immutable.fromJS(parsedInfoMarkerTruck)
        .mapEntries(([k, v]) => [k, createFormatter(v)])
        .toJSON();

      return entries;
    }
  }

  return {};
};

export const infoMarkerTruck = {
  formatterDefault: ({ key }) => key,
  formatters: createInfoMarkerConf()
};

export const formatInforMarkerTruck = (routeView) => {
  const { organization, key } = routeView.route;

  const formatter = createInfoMarkerConf()[organization.id];

  if (!formatter) {
    return infoMarkerTruck.formatterDefault({ key });
  }

  return formatter(routeView);
};
